module.exports = __webpack_public_path__ + "img/JAR.f714d745.png";